$(document).ready(function ($) {
  $(".elementor-form").on("submit_success", function (event, response) {
    if (!('klaviyo_newsletter' in response.data)) {
      return;
    }

    if (typeof window.fbq !== "undefined" && window.fbq != null) {
      window.fbq('track', 'CompleteRegistration');
      console.log('CompletedRegistration event');
    }
  });
});